import { Outlet, useNavigate } from "react-router-dom";
import React from 'react'

import { useEffect, useState } from "react";
import { baseURL } from "../../constants/const";
import axios from "axios";
import Logout from "../Logout/Logout";
import Navbar from "../Navbar/Navbar";
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { pageVariants } from "../../utils/animations";

const CHECK_AUTH_ENDPOINT = baseURL+'/check-auth';

const Layout = () => {
  
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const accessToken = localStorage.getItem('accessToken');

    if (accessToken) {
      try {
        const formData = new URLSearchParams();
        formData.append('accessToken', accessToken);
        const response = await axios.post(CHECK_AUTH_ENDPOINT, formData, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        });
        const isValid = response.data.isValid;
        setIsLoggedIn(isValid);

        if (!isValid) {
          handleLogout();
        }
      } catch (error) {
        // Handlovanje grešaka
      }
    } else {
      navigate('/login');
    }
  };
  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    setIsLoggedIn(false);
    navigate('/login');
  };

  const location = useLocation();

  return (
    <main className="App">
      <Navbar isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn}/>
      <AnimatePresence mode="wait">
        <motion.div
          key={location.pathname}
          variants={pageVariants}
          initial = "initial"
          animate = "animate"
          exit="exit"
        >
          <Outlet />
        </motion.div>
      </AnimatePresence>
    </main>
  )
}

export default Layout
